module.exports = __webpack_public_path__ + "components/flag/static/square/gy-e7c9fef0fba456ad476824f3b732cf7b.svg";